export interface GtmHelper {
  formatNumber(number: number | null | undefined) : string | null
  format(value: string | null | undefined) : string | null
}

export const gtmHelper: GtmHelper = {
  formatNumber(number: number | null | undefined) : string | null {
    return number !== null && number !== undefined ? 
            number.toLocaleString('fr', { 
              minimumFractionDigits: 0, 
              maximumFractionDigits: 2,
              useGrouping: false
            }) : 
            null
  },  
  format(value: string | null | undefined) : string | null {                    
    // Replace whitespaces by underscores, lowercase only, and max 500 chars.
    return value ?
            value.replace(/\s/g, '_').toLowerCase().substring(0, 500) :
            null        
  }
}
